export default `

.station {
  background: red;
  width: 12px;
  height: 12px;
  border-radius: 20px;
}

.station:hover {
  background: blue;

}

`;



// WEBPACK FOOTER //
// ./src/components/MapboxWrapper/marker-style2.js